const mod = crateImports["@xing-com/crate-xinglet/internal"];
const { InternalXingletLoader,RouteProvider,RuntimeContext,RuntimeProvider,createServerRequest,getEntryPointConfig,useRuntime,useRuntimeConfig } = mod;
export { InternalXingletLoader,RouteProvider,RuntimeContext,RuntimeProvider,createServerRequest,getEntryPointConfig,useRuntime,useRuntimeConfig };
export default mod.default ?? mod;